/* TRICK OR ICE 2026 のお店の仕組み（神城 2026-10-18。オーナー10/18「タイムセールの中に該当の時計を全てぶち込む」
   「元値が分かった上で値引きされていることのわかる価格表示」「どの商品を選んでいても、3万円以上でブレスレットが選べる、
   5万円以上でセットが選べるということが伝わる表示」「実際に定めた金額以上買ったお客様にはテニスを選ばせる仕組み」）
   ① 期間（10/22 23:50〜10/31 23:59 JST。開始はオーナー10/18の指示で10分早めた）だけ動く。時刻はお店のサーバーの時計（/cart.js の応答の Date）で判定する。
      下書きテーマのプレビューでは常に表示する（ただしページの移動・カートの差し替え・特典を外す処理はしない）。
   ② 元の時計16本 → 期間中はタイムセールの複製（¥19,800・元値に取り消し線）へ寄せる：商品ページは複製へ移動、
      一覧は同じ一覧に複製があれば元のカードを隠し、無ければリンク・値段・カートに入れるボタンを複製へ付け替える。
      カートに元の時計が入っていたら複製に差し替える。期間が終わったら逆（複製→元）。
   ③ どの商品ページにも、¥30,000／¥50,000の特典と「今のカートであといくら」を出す。
   ④ カート（引き出し・カートのページ）に、あといくらと「特典を選ぶ」欄。¥0の特典商品を足す。
      金額＝カートの合計（2BUY1FREE などの自動割引の後・送料なし）。条件を外れた特典・2つ目以降・期間外の特典は自動で外す。
   表は eh-toi-data.js。戻す＝layout/theme.liquid の </body> 直前の TRICK OR ICE の3行を消す。 */
(function () {
  'use strict';
  if (window.__ehToiShop) return;
  window.__ehToiShop = true;
  var D = window.EH_TOI_DATA;
  if (!D) return;

  var START = Date.parse('2026-10-22T23:50:00+09:00'); // オーナー10/18「23:50に公開…10分のフライングを許可」
  var END = Date.parse('2026-11-01T00:00:00+09:00');
  var T1 = 30000, T2 = 50000;
  var SH = window.Shopify || {};
  var PREVIEW = !!(SH.theme && SH.theme.role && SH.theme.role !== 'main') || /[?&]ehpreview=1/.test(location.search);
  var EN = SH.locale === 'en';
  var skew = 0;
  function now() { return Date.now() + skew; }
  function live() { var t = now(); return t >= START && t < END; }
  function on() { return PREVIEW || live(); }
  function ended() { return !PREVIEW && now() >= END; }

  var O2C = {}, C2O = {}, OV2CV = {}, CV2OV = {}, i;
  for (i = 0; i < D.W.length; i++) {
    O2C[D.W[i][0]] = D.W[i];
    C2O[D.W[i][2]] = D.W[i];
    OV2CV[D.W[i][1]] = D.W[i][3];
    CV2OV[D.W[i][3]] = D.W[i][1];
  }
  var GIFT_HANDLES = { 'trick-or-ice-gift-bracelet': 1, 'trick-or-ice-gift-necklace': 1 };
  var COLORS = ['18K Gold Plated', 'White Gold', 'Rose Gold'];
  var SIZES = { b: ['6 (15cm)', '7 (18cm)', '8 (20cm)', '9 (23cm)'], n: ['16 (40cm)', '18 (45cm)', '20 (50cm)', '22 (55cm)', '24 (60cm)'] };
  var DEF_SIZE = { b: '7 (18cm)', n: '20 (50cm)' };

  function yen(n) { return '¥' + Math.round(n).toLocaleString('ja-JP'); }
  function root() { return (SH.routes && SH.routes.root) || '/'; }
  function purl(h) { return root() + 'products/' + encodeURIComponent(h); }
  function handleOf(href) {
    try {
      var p = decodeURIComponent(new URL(href, location.href).pathname);
      var m = p.match(/\/products\/([^\/?#]+)/);
      return m ? m[1] : '';
    } catch (e) { return ''; }
  }
  function findGift(kind, th, color, size) {
    for (var id in D.G) {
      var g = D.G[id];
      if (g[0] === kind && g[1] === th && g[2] === color && g[3] === size) return +id;
    }
    return 0;
  }

  var CSS = [
    '.eh-toi-box{margin:12px 0 14px;padding:14px 14px 12px;border-radius:14px;color:#f7efe2;line-height:1.45;text-align:left;',
    'background:radial-gradient(120% 140% at 0% 0%,#3a2346 0%,#1b1322 55%,#120d17 100%);box-shadow:0 12px 26px -16px rgba(0,0,0,.9),inset 0 0 0 1px rgba(255,150,60,.35);}',
    '.eh-toi-box__kicker{display:block;font-size:11px;font-weight:800;letter-spacing:.12em;color:#ff9a3d;}',
    '.eh-toi-box__lead{display:block;margin-top:2px;font-size:16px;font-weight:900;color:#fff;}',
    '.eh-toi-box__lead b{color:#ffb35c;}',
    '.eh-toi-tiers{list-style:none;margin:8px 0 0;padding:0;}',
    '.eh-toi-tiers li{display:flex;gap:8px;align-items:baseline;margin:3px 0;font-size:13px;font-weight:700;}',
    '.eh-toi-tiers li b{min-width:76px;color:#ffb35c;font-size:14px;}',
    '.eh-toi-tiers li.is-ok{color:#9fe3b0;}',
    '.eh-toi-bar{position:relative;height:8px;margin:10px 0 4px;border-radius:99px;background:rgba(255,255,255,.14);overflow:hidden;}',
    '.eh-toi-bar i{position:absolute;left:0;top:0;bottom:0;border-radius:99px;background:linear-gradient(90deg,#ff7a1a,#ffcf6b);}',
    '.eh-toi-bar s{position:absolute;top:-2px;bottom:-2px;width:2px;background:rgba(255,255,255,.6);}',
    '.eh-toi-note{display:block;margin-top:6px;font-size:11px;color:rgba(247,239,226,.75);}',
    '.eh-toi-msg{display:block;margin-top:8px;padding:7px 9px;border-radius:9px;background:rgba(255,122,26,.18);font-size:12px;font-weight:700;color:#ffd7ae;}',
    '.eh-toi-pick{margin-top:10px;padding:10px;border-radius:11px;background:rgba(255,255,255,.07);}',
    '.eh-toi-pick__title{display:block;font-size:13px;font-weight:900;color:#fff;}',
    '.eh-toi-pick__title small{font-weight:700;color:#ffb35c;}',
    '.eh-toi-pick__row{display:flex;flex-wrap:wrap;gap:6px;margin-top:8px;}',
    '.eh-toi-pick select{flex:1 1 30%;min-width:92px;height:36px;padding:0 8px;border-radius:8px;border:1px solid rgba(255,255,255,.3);background:#fff;color:#1b1322;font-size:13px;}',
    '.eh-toi-pick button{width:100%;margin-top:8px;height:40px;border:0;border-radius:10px;background:linear-gradient(90deg,#ff7a1a,#ffb347);color:#1b1322;font-size:14px;font-weight:900;cursor:pointer;}',
    '.eh-toi-pick button[disabled]{opacity:.6;cursor:wait;}',
    '.eh-toi-got{display:flex;justify-content:space-between;gap:8px;align-items:center;margin-top:8px;padding:8px 10px;border-radius:10px;background:rgba(159,227,176,.12);font-size:12px;font-weight:700;color:#d9f5df;}',
    '.eh-toi-got a{color:#ffb35c;text-decoration:underline;white-space:nowrap;cursor:pointer;}',
    '.eh-toi-got del{opacity:.7;}',
    '.ajaxcart__inner .eh-toi-box{margin:0 0 16px;}',
    '.template-cart .eh-toi-box{max-width:420px;margin:0 0 14px auto;}',
    '@media(max-width:767px){.template-cart .eh-toi-box{max-width:none;margin:0 0 14px;}}'
  ].join('');

  var T = EN ? {
    kicker: 'TRICK OR ICE｜UNTIL 10/31', lead: 'Free tennis jewelry with your order',
    t1: 'Tennis bracelet (3mm/4mm) FREE', t2: 'Necklace + bracelet (up to 5mm) FREE',
    left1: function (n) { return yen(n) + ' more for a FREE tennis bracelet'; },
    left2: function (n) { return yen(n) + ' more and the necklace is FREE too'; },
    got1: 'You can choose a FREE tennis bracelet!', got2: 'You can choose a FREE necklace + bracelet!',
    note: 'Judged on the cart total after discounts such as 2BUY1FREE.',
    pickB: 'Choose your FREE bracelet', pickN: 'Choose your FREE necklace', add: 'Add for ¥0',
    change: 'Change', gift: 'Gift', preview: '(Preview) Gift items go live on 10/23 0:00.',
    removed: 'A gift was removed because the cart is below the amount.', swapped: 'Switched to the TRICK OR ICE price (¥19,800).',
    watch: '2BUY1FREE also applies: 3 watches for ¥39,600 + a FREE tennis bracelet', giftPage: 'This is a TRICK OR ICE gift. Choose it in your cart.'
  } : {
    kicker: 'TRICK OR ICE｜10/31(土)まで', lead: 'お買い物で<b>テニスチェーンが無料</b>',
    t1: 'テニスブレスレット（3mm・4mm）', t2: 'ネックレス＋ブレスレット（5mmも・最大¥31,515分）',
    left1: function (n) { return 'あと<b>' + yen(n) + '</b>でテニスブレスレットが無料'; },
    left2: function (n) { return 'あと<b>' + yen(n) + '</b>でネックレスも無料'; },
    got1: 'テニスブレスレットが<b>無料</b>で選べます', got2: 'ネックレス＋ブレスレットが<b>無料</b>で選べます',
    note: '2BUY1FREEなどの割引の後の金額で判定します（送料は含みません）。',
    pickB: 'テニスブレスレットを選ぶ', pickN: 'テニスネックレスを選ぶ', add: '¥0でカートに入れる',
    change: '選び直す', gift: '特典', preview: '（プレビュー）特典の商品は10/23 0:00に公開されます。',
    removed: '合計が条件を下回ったため、特典を外しました。', swapped: 'TRICK OR ICE の価格（¥19,800）に切り替えました。',
    watch: '2BUY1FREEと併用OK：3本で¥39,600＋テニスブレスレット無料', giftPage: 'この商品は TRICK OR ICE の特典です。カートの「特典を選ぶ」から¥0で追加できます。'
  };

  var lastCart = null, msg = '', busy = false, seq = 0;

  function api(path, body) {
    var opt = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) { opt.method = 'POST'; opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    return fetch(root() + path, opt).then(function (r) {
      var d = r.headers && r.headers.get('Date');
      if (d && !isNaN(Date.parse(d))) skew = Date.parse(d) - Date.now();
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }

  function paidOf(cart) {
    var gift = 0;
    for (var k = 0; k < cart.items.length; k++) if (D.G[cart.items[k].variant_id]) gift += cart.items[k].final_line_price;
    return (cart.total_price - gift) / 100;
  }
  function tierOf(p) { return p >= T2 ? 2 : p >= T1 ? 1 : 0; }

  function themeReload() {
    if (document.body && /template-cart/.test(document.body.className)) { location.reload(); return; }
    try { if (window.ajaxCart && window.ajaxCart.load) window.ajaxCart.load(); } catch (e) {}
  }

  // カートの中身を条件に合わせる（差し替え・特典を外す）。プレビューでは何もしない
  function plan(cart) {
    var acts = [], k, it, g, keptB = false, keptN = false, tier = tierOf(paidOf(cart));
    if (PREVIEW) return acts;
    for (k = 0; k < cart.items.length; k++) {
      it = cart.items[k];
      if (live() && OV2CV[it.variant_id]) acts.push({ swap: it, to: OV2CV[it.variant_id] });
      else if (ended() && CV2OV[it.variant_id]) acts.push({ swap: it, to: CV2OV[it.variant_id] });
    }
    if (acts.length) return acts;
    for (k = 0; k < cart.items.length; k++) {
      it = cart.items[k];
      g = D.G[it.variant_id];
      if (!g) continue;
      var ok = live() && (g[0] === 'b' ? (tier === 2 || (tier === 1 && g[1] !== '5mm')) && !keptB : tier === 2 && !keptN);
      if (ok) {
        if (g[0] === 'b') keptB = true; else keptN = true;
        if (it.quantity > 1) acts.push({ set: it, q: 1 });
      } else acts.push({ set: it, q: 0, gift: true });
    }
    return acts;
  }

  function apply(acts) {
    var p = Promise.resolve();
    acts.forEach(function (a) {
      p = p.then(function () {
        if (a.swap) {
          return api('cart/change.js', { id: a.swap.key, quantity: 0 }).then(function () {
            return api('cart/add.js', { items: [{ id: a.to, quantity: a.swap.quantity }] });
          }).then(function () { msg = T.swapped; });
        }
        return api('cart/change.js', { id: a.set.key, quantity: a.q }).then(function () { if (a.gift) msg = T.removed; });
      });
    });
    return p;
  }

  function sync() {
    if (busy) return Promise.resolve(lastCart);
    busy = true;
    var my = ++seq;
    return api('cart.js').then(function (cart) {
      var acts = plan(cart);
      if (!acts.length) return cart;
      return apply(acts).then(function () { return api('cart.js'); }).then(function (c2) {
        var more = plan(c2);
        return (more.length ? apply(more).then(function () { return api('cart.js'); }) : c2);
      }).then(function (c3) { themeReload(); return c3; });
    }).then(function (cart) {
      busy = false;
      if (my !== seq) return cart;
      lastCart = cart;
      paint();
      return cart;
    })['catch'](function () { busy = false; });
  }

  // ----- 表示 -----
  function giftLines(cart, kind) {
    var out = [];
    if (!cart) return out;
    for (var k = 0; k < cart.items.length; k++) {
      var g = D.G[cart.items[k].variant_id];
      if (g && g[0] === kind) out.push({ it: cart.items[k], g: g });
    }
    return out;
  }

  function tiersHTML(paid) {
    var t = tierOf(paid), pct = Math.min(100, paid / T2 * 100);
    var h = '<ul class="eh-toi-tiers"><li' + (t >= 1 ? ' class="is-ok"' : '') + '><b>¥30,000〜</b><span>' + T.t1 + '</span></li>' +
      '<li' + (t >= 2 ? ' class="is-ok"' : '') + '><b>¥50,000〜</b><span>' + T.t2 + '</span></li></ul>';
    h += '<div class="eh-toi-bar"><i style="width:' + pct.toFixed(1) + '%"></i><s style="left:60%"></s></div>';
    if (t === 0) h += '<span class="eh-toi-box__lead">' + T.left1(T1 - paid) + '</span>';
    else if (t === 1) h += '<span class="eh-toi-box__lead">' + T.got1 + '</span><span class="eh-toi-note">' + T.left2(T2 - paid) + '</span>';
    else h += '<span class="eh-toi-box__lead">' + T.got2 + '</span>';
    return h;
  }

  function opts(list, sel) {
    var h = '';
    for (var k = 0; k < list.length; k++) h += '<option value="' + list[k] + '"' + (list[k] === sel ? ' selected' : '') + '>' + list[k] + '</option>';
    return h;
  }

  function pickHTML(kind, tier) {
    var ths = kind === 'n' || tier === 2 ? ['3mm', '4mm', '5mm'] : ['3mm', '4mm'];
    var title = kind === 'b' ? T.pickB : T.pickN;
    return '<div class="eh-toi-pick" data-kind="' + kind + '"><span class="eh-toi-pick__title">' + title + ' <small data-val></small></span>' +
      '<div class="eh-toi-pick__row"><select data-th>' + opts(ths, ths[ths.length - 1]) + '</select>' +
      '<select data-color>' + opts(COLORS, COLORS[0]) + '</select>' +
      '<select data-size>' + opts(SIZES[kind], DEF_SIZE[kind]) + '</select></div>' +
      '<button type="button" data-add>' + T.add + '</button></div>';
  }

  function gotHTML(x) {
    var g = x.g, name = (g[0] === 'b' ? (EN ? 'Tennis bracelet' : 'テニスブレスレット') : (EN ? 'Tennis necklace' : 'テニスネックレス'));
    return '<div class="eh-toi-got"><span>✓ ' + T.gift + '：' + name + ' ' + g[1] + ' / ' + g[2] + ' / ' + g[3] +
      '（<del>' + yen(g[4]) + '</del> → ¥0）</span><a data-change="' + x.it.key + '">' + T.change + '</a></div>';
  }

  function cartBoxHTML(cart) {
    var paid = paidOf(cart), tier = tierOf(paid), h = '';
    h += '<span class="eh-toi-box__kicker">' + T.kicker + '</span>';
    h += tiersHTML(paid);
    var b = giftLines(cart, 'b'), n = giftLines(cart, 'n');
    if (tier >= 1) { if (b.length) h += gotHTML(b[0]); else h += pickHTML('b', tier); }
    if (tier >= 2) { if (n.length) h += gotHTML(n[0]); else h += pickHTML('n', tier); }
    h += '<span class="eh-toi-note">' + T.note + '</span>';
    if (msg) h += '<span class="eh-toi-msg">' + msg + '</span>';
    return h;
  }

  function productBoxHTML(cart, handle) {
    var paid = cart ? paidOf(cart) : 0, h = '<span class="eh-toi-box__kicker">' + T.kicker + '</span>';
    if (C2O[handle]) h += '<span class="eh-toi-box__lead"><b>' + T.watch + '</b></span>';
    else h += '<span class="eh-toi-box__lead">' + T.lead + '</span>';
    h += tiersHTML(paid) + '<span class="eh-toi-note">' + T.note + '</span>';
    return h;
  }

  function updatePickValue(box) {
    var picks = box.querySelectorAll('.eh-toi-pick');
    for (var k = 0; k < picks.length; k++) {
      var p = picks[k], kind = p.getAttribute('data-kind');
      var id = findGift(kind, p.querySelector('[data-th]').value, p.querySelector('[data-color]').value, p.querySelector('[data-size]').value);
      var v = p.querySelector('[data-val]');
      if (v) v.innerHTML = id ? '（<del>' + yen(D.G[id][4]) + '</del> → ¥0）' : '';
    }
  }

  function bind(box) {
    if (box.__ehBound) return;
    box.__ehBound = true;
    box.addEventListener('change', function () { updatePickValue(box); });
    box.addEventListener('click', function (e) {
      var t = e.target;
      if (t.hasAttribute && t.hasAttribute('data-add')) {
        var p = t.closest('.eh-toi-pick'), kind = p.getAttribute('data-kind');
        var id = findGift(kind, p.querySelector('[data-th]').value, p.querySelector('[data-color]').value, p.querySelector('[data-size]').value);
        if (!id) return;
        t.disabled = true;
        msg = '';
        api('cart/add.js', { items: [{ id: id, quantity: 1, properties: { '_TRICK OR ICE': 'gift' } }] })
          .then(function () { themeReload(); return sync(); })['catch'](function () { msg = PREVIEW ? T.preview : T.removed; t.disabled = false; paint(); });
      } else if (t.hasAttribute && t.hasAttribute('data-change')) {
        e.preventDefault();
        msg = '';
        api('cart/change.js', { id: t.getAttribute('data-change'), quantity: 0 }).then(function () { themeReload(); return sync(); });
      }
    });
  }

  function place(where, html) {
    var targets = [], k;
    if (where === 'cart') {
      var inners = document.querySelectorAll('[data-cart-container] .ajaxcart__inner');
      for (k = 0; k < inners.length; k++) targets.push({ parent: inners[k], before: inners[k].querySelector('.ajaxcart__product') });
      var totals = document.querySelectorAll('#cart-form .cart-total');
      for (k = 0; k < totals.length; k++) targets.push({ parent: totals[k], before: totals[k].querySelector('.cart-total__subtotal') });
    } else {
      var pc = document.querySelector('.product-single__metas [data-price-container]') || document.querySelector('[data-price-container]');
      if (pc) targets.push({ parent: pc.parentNode, before: pc.nextSibling });
    }
    for (k = 0; k < targets.length; k++) {
      var t = targets[k], box = t.parent.querySelector(':scope > .eh-toi-box[data-where="' + where + '"]');
      if (!box) {
        box = document.createElement('div');
        box.className = 'eh-toi-box';
        box.setAttribute('data-where', where);
        t.parent.insertBefore(box, t.before && t.before.parentNode === t.parent ? t.before : null);
      }
      if (box.__ehHtml !== html) { box.innerHTML = html; box.__ehHtml = html; updatePickValue(box); }
      bind(box);
    }
  }

  function pageHandle() {
    var m = decodeURIComponent(location.pathname).match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  function paint() {
    if (!on()) {
      var old = document.querySelectorAll('.eh-toi-box');
      for (var k = 0; k < old.length; k++) old[k].parentNode.removeChild(old[k]);
      return;
    }
    var h = pageHandle();
    if (h && !GIFT_HANDLES[h]) place('product', productBoxHTML(lastCart, h));
    if (lastCart && lastCart.item_count > 0) place('cart', cartBoxHTML(lastCart));
  }

  // ----- 元の時計 ⇄ タイムセールの複製（期間中だけ。プレビューでは動かさない） -----
  function redirectIfNeeded() {
    if (PREVIEW) return false;
    var h = pageHandle();
    if (live() && O2C[h]) { location.replace(purl(O2C[h][2]) + location.search); return true; }
    if (ended() && C2O[h]) { location.replace(purl(C2O[h][0]) + location.search); return true; }
    if (!live() && GIFT_HANDLES[h]) { location.replace(root()); return true; }
    return false;
  }

  function fixLinks() {
    if (PREVIEW) return;
    var map = live() ? O2C : ended() ? C2O : null, to = live() ? 2 : 0;
    if (!map) return;
    var as = document.querySelectorAll('a[href*="/products/"]'), k, h;
    for (k = 0; k < as.length; k++) {
      h = handleOf(as[k].getAttribute('href'));
      if (map[h]) as[k].setAttribute('href', purl(map[h][to]));
    }
    var qv = document.querySelectorAll('[data-handle]');
    for (k = 0; k < qv.length; k++) {
      h = qv[k].getAttribute('data-handle');
      if (!map[h]) continue;
      var card = qv[k].closest('.product-card');
      if (!card || card.__ehDone) continue;
      card.__ehDone = true;
      var twin = document.querySelector('.product-card [data-handle="' + map[h][to] + '"]');
      if (twin) {
        var wrap = card.parentNode && card.parentNode.children.length === 1 ? card.parentNode : card;
        wrap.style.display = 'none';
      } else {
        var forms = card.querySelectorAll('.product-card__form, .product-card__quickview');
        for (var f = 0; f < forms.length; f++) forms[f].style.display = 'none';
        var pr = card.querySelector('.product-group-price');
        if (pr && live()) pr.innerHTML = '<div class="product-price product-price--regular">' + yen(map[h][4]) + '</div><div class="product-price price-sale">¥19,800</div>';
      }
    }
  }

  function giftPage() {
    if (!GIFT_HANDLES[pageHandle()] || !on()) return;
    var b = document.querySelector('.product-single__buttons');
    if (b && !b.__ehDone) {
      b.__ehDone = true;
      b.style.display = 'none';
      var n = document.createElement('p');
      n.className = 'eh-toi-msg';
      n.innerHTML = T.giftPage + ' <a href="' + root() + 'cart" style="color:#ff9a3d;text-decoration:underline">→</a>';
      b.parentNode.insertBefore(n, b);
    }
  }

  // ----- きっかけ -----
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/;
  var tmr = null;
  function later(ms) { clearTimeout(tmr); tmr = setTimeout(sync, ms || 300); }
  var pq = false;
  function repaint() { if (pq) return; pq = true; setTimeout(function () { pq = false; paint(); fixLinks(); giftPage(); }, 60); }

  function run() {
    var st = document.createElement('style');
    st.id = 'eh-toi-shop-css';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
    api('cart.js').then(function (cart) {
      lastCart = cart;
      if (redirectIfNeeded()) return;
      fixLinks(); giftPage(); paint();
      sync();
    })['catch'](function () {});
    var $ = window.jQuery;
    if ($ && $.fn) $(document).ajaxComplete(function (e, x, s) { if (s && CART_RE.test(String(s.url || '')) && !busy) later(250); });
    if (window.PerformanceObserver) {
      try {
        new PerformanceObserver(function (l) {
          var es = l.getEntries();
          for (var k = 0; k < es.length; k++) if (es[k].initiatorType === 'xmlhttprequest' && CART_RE.test(es[k].name) && !busy) { later(250); return; }
        }).observe({ type: 'resource' });
      } catch (e) {}
    }
    if (window.MutationObserver) new MutationObserver(repaint).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', function (e) { if (e.persisted) later(10); });
    // 期間の始まり・終わりをまたいだら、その場で切り替える
    setInterval(function () { var s = on() + ':' + live() + ':' + ended(); if (s !== run.s) { run.s = s; if (!redirectIfNeeded()) later(10); } }, 15000);
    run.s = on() + ':' + live() + ':' + ended();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
